import styled from 'styled-components'
import { giphyAqua, giphyDarkGrey } from '../../styles/colors'
import GridTable from '../shared/grid-table'

const ConsoleWrapper = styled(GridTable)`
    table {
        width: 100%;
        border-collapse: collapse;
    }

    table th:not(:first-child) {
        padding-left: 10px;
    }

    td,
    ul {
        background: ${giphyDarkGrey};
        color: rgb(255, 255, 255);
        font-family: PTMono-Regular;
        font-size: 16px;
        border-radius: 2px;
        line-height: 33px;
        padding: 16px 0 16px 30px;
    }

    ul {
        list-style: none;
    }

    ul a {
        color: ${giphyAqua};
        border-bottom: 1px ${giphyAqua} solid;
    }
`

export default ConsoleWrapper
